import React from 'react';
import { levels, packItems } from '../data/content';
import { icons } from '../utils/icons';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
export function WhatsInside() {
  return <section id="inside" className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-223" data-mp="kv6h2ef883vp">
      <div className="mx-auto max-w-6xl" data-id="element-224" data-mp="put2vc94esg4">
        <SectionHeading eyebrow="Dentro il kit" title={<>
              Cosa c’è dentro il{' '}
              <span className="text-brand" data-id="element-226" data-mp="b4v7occrx2hf">Kit Inglese Pronto™</span>?
            </>} subtitle="Sei blocchi di materiale che coprono l’intero anno scolastico, dalla spiegazione grammaticale al test finale." data-id="element-225" data-mp="ptrg4aiqshik" />

        <Reveal delay={0.05} data-id="element-227" data-mp="27kycwjinnf5">
          <div className="mt-12 overflow-hidden rounded-2xl border-2 border-ink bg-bone" data-id="element-228" data-mp="74unsc6wnz2z">
            <div className="flex flex-wrap items-center justify-between gap-x-4 gap-y-1 border-b-2 border-ink px-5 py-3" data-id="element-229" data-mp="3ocycy3whh7z6">
              <span className="text-xs font-extrabold uppercase tracking-[0.16em] text-ink/60" data-id="element-230" data-mp="3tckom8wnyg5v">
                Un volume per livello QCER
              </span>
              <span className="text-xs font-extrabold uppercase tracking-[0.16em] text-brand" data-id="element-231" data-mp="3cw0j65yxvgjc">
                6 volumi inclusi
              </span>
            </div>

            <ul className="grid grid-cols-2 gap-3 p-5 sm:grid-cols-3 sm:gap-4 sm:p-6 lg:grid-cols-6" data-id="element-232" data-mp="3ltaxk071zlsh">
              {levels.map((level, index) => <li key={level.code} className={`flex h-20 flex-col items-center justify-center rounded-lg px-2 text-center ${index < 3 ? 'bg-ink text-volt' : 'bg-brand text-white'}`} data-id="element-233" data-mp="3hqwbl78385wz" data-mpi={index}>
                  <span className="font-display text-2xl leading-none" data-id="element-234" data-mp="2p667vsu9q017">
                    {level.code}
                  </span>
                  <span className="mt-1.5 text-[10px] font-bold uppercase tracking-[0.1em] opacity-75" data-id="element-235" data-mp="2y51hlewits99">
                    {level.name}
                  </span>
                </li>)}
            </ul>
          </div>
        </Reveal>

        <ul className="mt-6 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-236" data-mp="26en6trjt0w1t">
          {packItems.map((item, index) => {
          const Icon = icons[item.icon];
          return <Reveal key={item.title} delay={index * 0.04} className="h-full" data-id="element-237" data-mp="ecaqzbt1gwr8" data-mpi={index}>
                <li className="flex h-full flex-col rounded-2xl border-2 border-ink bg-white p-7 transition-transform duration-200 ease-out hover:-translate-y-1" data-id="element-238" data-mp="ea7rm15zxr9u">
                  <div className="flex items-center justify-between" data-id="element-239" data-mp="o12hdfigb901">
                    <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-ink text-volt" data-id="element-240" data-mp="3mk9bh14t5lcy">
                      <Icon className="h-6 w-6" aria-hidden="true" data-id="element-241" data-mp="3ri15q1sxdjkb" />
                    </span>
                    <span className="font-display text-2xl text-ink/10" data-id="element-242" data-mp="c9oxt11fja6">
                      {String(index + 1).padStart(2, '0')}
                    </span>
                  </div>
                  <h3 className="mt-6 font-display text-xl leading-tight text-ink" data-id="element-243" data-mp="1bryb4i6gwe9x">
                    {item.title}
                  </h3>
                  <p className="mt-3 text-base leading-relaxed text-ink/70" data-id="element-244" data-mp="1gpggxzp6uddp">
                    {item.text}
                  </p>
                </li>
              </Reveal>;
        })}
        </ul>
      </div>
    </section>;
}